/**
 * Helper utilities để check campaign buy-1-get-1-in-gift-shop và buy-1-get-1-value-match
 * Sử dụng cho cả server-side và client-side
 */

import type { CampaignInfo } from '@/providers/campaign-provider'
import { useCampaignActive } from '@/providers/campaign-provider'
import { CAMPAIGN_NAMES } from './campaign-names'

/**
 * Campaign name constant để tránh typo
 * @deprecated Sử dụng CAMPAIGN_NAMES.BUY_1_GET_1_IN_GIFT_SHOP thay vì constant này
 */
export const BUY_1_GET_1_IN_GIFT_SHOP_CAMPAIGN_NAME =
  CAMPAIGN_NAMES.BUY_1_GET_1_IN_GIFT_SHOP

/**
 * Check campaign buy-1-get-1-in-gift-shop có đang active không (server-side)
 * @param campaigns - Campaigns data từ CampaignProvider
 * @returns true nếu campaign đang active
 */
export function isBuy1Get1InGiftShopCampaignActive(
  campaigns: Record<string, CampaignInfo>
): boolean {
  const campaign = campaigns[CAMPAIGN_NAMES.BUY_1_GET_1_IN_GIFT_SHOP]
  return !!campaign?.isActive
}

/**
 * Hook để check campaign buy-1-get-1-in-gift-shop có đang active không (client-side)
 * @returns true nếu campaign đang active
 */
export function useIsBuy1Get1InGiftShopCampaignActive(): boolean {
  return useCampaignActive(CAMPAIGN_NAMES.BUY_1_GET_1_IN_GIFT_SHOP)
}

/**
 * Check campaign buy-1-get-1-value-match có đang active không (server-side)
 * @param campaigns - Campaigns data từ CampaignProvider
 * @returns true nếu campaign đang active
 */
export function isBuy1Get1ValueMatchCampaignActive(
  campaigns: Record<string, CampaignInfo>
): boolean {
  const campaign = campaigns[CAMPAIGN_NAMES.BUY_1_GET_1_VALUE_MATCH]
  return !!campaign?.isActive
}

/**
 * Hook để check campaign buy-1-get-1-value-match có đang active không (client-side)
 * @returns true nếu campaign đang active
 */
export function useIsBuy1Get1ValueMatchCampaignActive(): boolean {
  return useCampaignActive(CAMPAIGN_NAMES.BUY_1_GET_1_VALUE_MATCH)
}
